import React from "react";
import { Avatar, AvatarProps } from "@chakra-ui/avatar";
import { pickRandom } from "utils";

const AvatarIcon: React.FC<AvatarProps> = (props: AvatarProps) => {
  const colorValue = pickRandom(["blue", "gray"]);
  const colorIndex = pickRandom([100, 200, 300, 400, 500, 600, 700, 800]);
  return (
    <Avatar
      bg={`${colorValue}.${colorIndex}`}
      color={colorIndex < 600 ? "gray.900" : "white"}
      {...props}
    />
  );
};

export default AvatarIcon;
